module.exports = __webpack_public_path__ + "static/media/jest.450c112d.png";